// extracted by mini-css-extract-plugin
export default {"wraper":"TowerPostsList_wraper__maEW-","list_posts":"TowerPostsList_list_posts__2ZZL6","arrowLeft":"TowerPostsList_arrowLeft__+nogF","arrowRight":"TowerPostsList_arrowRight__CHMm3"};